import React, { FC } from 'react';

const NotFound: FC = () => (
  <div>Something went wrong!</div>
);

export default NotFound;
